import React from 'react';
import { InputPrefix as DNAInputPrefix } from '@justgiving/dna-form';
import { InputProps } from 'src/helpers/forms';

interface Props {
  id: string;
  className: string;
  prefix: string;
  type: string;
  min?: string;
  max?: string;
}

class PrefixedInput extends React.Component<Props & InputProps, {}> {
  input: HTMLElement;
  prefix: any;

  componentDidMount() {
    this.prefix = new DNAInputPrefix({
      el: this.input,
    });
  }

  componentWillUnmount() {
    delete this.prefix;
  }

  render() {
    const { className, prefix, ...input } = this.props;

    return (
      <input
        ref={c => {
          this.input = c as HTMLInputElement;
        }}
        {...input}
        className={`${className} js-dna-input-prefix`}
        data-dna-input-prefix={prefix}
      />
    );
  }
}

export default PrefixedInput;



// WEBPACK FOOTER //
// ./src/components/dna/PrefixedInput.tsx